export default __webpack_public_path__ + "static/voting-c51aee0553305b55a6d5a72e9d629309.jpg";